if (!customElements.get('sticky-atc')) {
  class StickyATC extends HTMLElement {
    constructor() {
      super()
      this.trigger = this.querySelector('[data-trigger]')
      this.sizes = this.querySelector('[data-sizes]')
      this.close = this.querySelector('[data-close]')
      this.productVariants = document.querySelector('.product__variants')
      this.overlayBG = document.querySelector('.overlay-bg')
      this.productVariantsBounds = {}
      this.currentScrollTop = 0
      this.mql = window.matchMedia('(max-width: 999px)')
      this.handleClose = this.collapse.bind(this)
      this.handleExpansionToggle = this.toggleExpansion.bind(this)
      this.handleScroll = this.onScroll.bind(this)

      this.getBounds()
      this.onScroll()
    }

    connectedCallback() {
      this.trigger.addEventListener('click', this.handleExpansionToggle)
      this.close.addEventListener('click', this.handleClose)

      if (this.productVariants) {
        window.addEventListener('scroll', this.handleScroll, false)
      }

      if (this.overlayBG) {
        this.overlayBG.addEventListener('click', this.handleClose)
      }
    }

    disconnectedCallback() {
      this.trigger.removeEventListener('click', this.handleExpansionToggle)
      this.close.removeEventListener('click', this.handleClose)

      if (this.productVariants) {
        window.removeEventListener('scroll', this.handleScroll)
      }

      if (this.overlayBG) {
        this.overlayBG.removeEventListener('click', this.handleClose)
      }
    }

    getBounds() {
      this.currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop
      const bounds = this.productVariants.getBoundingClientRect()
      const offsetProps = ['y', 'top', 'bottom']
      for (const property in bounds) {
        let value = bounds[property]

        if (offsetProps.includes(property)) {
          value += this.currentScrollTop
        }

        this.productVariantsBounds[property] = value
      }
    }

    onScroll() {
      if (!this.mql.matches) return

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollBottom = (scrollTop + window.innerHeight) / 2

      if (scrollBottom <= this.productVariantsBounds.bottom && this.isVisible()) {
        requestAnimationFrame(this.hide.bind(this))
      } else if (
        scrollBottom > this.productVariantsBounds.bottom &&
        !this.isVisible()
      ) {
        requestAnimationFrame(this.reveal.bind(this))
      }

      this.currentScrollTop = scrollTop
    }

    isVisible() {
      return this.getAttribute('aria-hidden') === 'false'
    }

    reveal() {
      this.setAttribute('aria-hidden', false)
    }

    hide() {
      this.setAttribute('aria-hidden', true)
    }

    toggle() {
      this.isVisible() ? this.hide() : this.reveal()
    }

    isExpanded() {
      return this.sizes.getAttribute('aria-hidden') === 'false'
    }

    expand() {
      this.trigger.setAttribute('aria-expanded', true)
      this.sizes.setAttribute('aria-hidden', false)

      // if (bodyScrollLock) {
      //   bodyScrollLock.disableBodyScroll(this)
      // }

      document.body.classList.add('has-overlay')
    }

    collapse() {
      this.trigger.setAttribute('aria-expanded', false)
      this.sizes.setAttribute('aria-hidden', true)

      if (bodyScrollLock) {
        bodyScrollLock.enableBodyScroll(this)
      }

      const overlays = document.querySelectorAll('[data-overlay]')
      for (const overlay of overlays) {
        const isVisible = overlay.getAttribute('aria-hidden') === 'false'

        if (overlay !== this.sizes && isVisible) {
          return
        }
      }

      document.body.classList.remove('has-overlay')
    }

    toggleExpansion() {
      this.isExpanded() ? this.collapse() : this.expand()
    }
  }

  customElements.define('sticky-atc', StickyATC)
}
